// eslint-disable-next-line no-restricted-imports
import { SvgIcon, SvgIconProps } from '@mui/material';
import Svg from '@rhg/../public/_n/images/icons/988-badge.svg';

export const Crisis988Badge = (props: SvgIconProps) => (
    <SvgIcon
        component={Svg}
        inheritViewBox
        style={{ width: 88, height: 88 }}
        {...props}
    />
);
